module.exports = __webpack_public_path__ + "nc_static/media/deviceStatus.99c2ca28.svg";